import React, { useEffect } from "react";
import { CreateMappingProvider } from "./autocompleteMapper";

const [RoutesMapProvider, useRoutesMap, RoutesMappingContext] =
  CreateMappingProvider("/v2/routes", (body: string[]) => {
    const unique = Array.from(new Set(body).values());
    return unique.reduce(
      (obj, val) => ({
        ...obj,
        [val]: `${val}`,
      }),
      {}
    );
  });

export { RoutesMapProvider, useRoutesMap, RoutesMappingContext };
